const userInterface = {
    nom: '',
    prenom: '',
    email: '',
    role: '3',
    tel: '',
    adresse: '',
    photo: '',
    buildStatus: 0,
    password: '',
    passwordConfirm: ''
  };
  
  export default userInterface;
  